// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsSetupZenConnect_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 17C18 18.6569 16.6569 20 15 20C14.1114 20 13.313 19.6136 12.7636 18.9997L5.96298 22.5274C5.98735 22.6813 6 22.8392 6 23C6 23.1521 5.98868 23.3016 5.96682 23.4477L12.9583 26.8019C13.4938 26.3043 14.2114 26 15 26C16.6569 26 18 27.3431 18 29C18 30.6569 16.6569 32 15 32C13.3431 32 12 30.6569 12 29C12 28.8556 12.0102 28.7137 12.0299 28.5747L5.02456 25.2139C4.49095 25.7021 3.78026 26 3 26C1.34315 26 0 24.6569 0 23C0 21.3431 1.34315 20 3 20C3.77174 20 4.47542 20.2914 5.00701 20.7702L12.0033 17.1411C12.0011 17.0943 12 17.0473 12 17C12 15.3431 13.3431 14 15 14C16.6569 14 18 15.3431 18 17Z" class="svg-bg"/>
  <path d="M2 2H30V19H19.584C19.2361 19.7963 18.6868 20.4844 18.0005 21H32V0H0V18.9996C0.581411 18.5629 1.26112 18.25 2 18.1V2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsSetupZenConnect is a generated icon component.
 */
let IconRmsSetupZenConnect = IconRmsSetupZenConnect_1 = class IconRmsSetupZenConnect extends IconBaseElement {
    render() {
        return html `${IconRmsSetupZenConnect_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsSetupZenConnect.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsSetupZenConnect = IconRmsSetupZenConnect_1 = __decorate([
    customElement('zui-icon-rms-setup-zen-connect')
], IconRmsSetupZenConnect);
export { IconRmsSetupZenConnect };
